import { useBaseLocalePicker } from 'articleEditor/components/localePicker/useBaseLocalePicker';

export const LocalePicker = (): JSX.Element => {
  return useBaseLocalePicker({
    tabRenderer: (language, renderDeleteButton) => renderDeleteButton(language),
  });
};
